export const formatEuro = (amount: number): string => {
  return `${amount.toFixed(2).replace('.', ',')} €`
}
